<template>
  <div class="newscenter">
    <header-view :tabsign="4"></header-view>
    <div class="pic">新闻中心</div>
    <div class="body w12 min-h">
      <div class="toptitle">
        <div class="left_c">
          <div class="redcon"></div>
          <span>新闻中心</span>
        </div>
      </div>

      <div class="centent">
        <div class="lista">
          <div
                  v-for="(item, index) in typelist"
                  class="listsignle"
                  @click="changetab(index,item)"
                  :key="index"
          >
            <div :class="index == indexsign ? 'signlea_cur' : 'signlea'">
              <div>{{ item.typeName||'' }}</div>
            </div>
            <div v-if="index<typelist.length-1" :class="index == indexsign ? '' : 'linecon'"></div>
          </div>
        </div>
        <div class="listb">
          <div v-for="(item, index) in list" :key="index">
            <div @click="toDatail(index, item)" class="signleb">
              <div class="titlecon overf-elli" :title="item.title">
                {{ item.title || "" }}
              </div>
              <div class="timecon">
                {{ item.createTime || "" }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <zhini-pagination
        class="zhini-pagination"
        :currentPage="pageNo"
        :totalPage="totalPage"
        @pageNum="pageNum"
      ></zhini-pagination>
  </div>
</template>

<script>
import zhiniPagination from "../../components/zhini-pagination.vue";
export default {
  name: "notice",
  components: {
    zhiniPagination,
  },
  data: function () {
    return {
      list: "",
      pageNo: 1,
      pageSize: 8,
      totalPage: 0,
      url: "",

      typesign: 0,
      indexsign: 0,
      typeId:'',
      typelist:[],
      searchv: "",
    };
  },
  created() {
    this.getType();
	window.pageYOffset = 0;
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;
  },
  watch: {
    $route() {
      this.typesign = this.$route.query.type;
    },
    typesign() {
      this.typesign = this.$route.query.type;
      this.init();
    },
  },
  methods: {
    //搜索
    changeinput() {
      this.init();
    },

    toDatail(indexsign, item) {
        this.$router.push({
			path: "/newscenterdetail",
			query: { index: indexsign, id: item.id },
        });
    },

    getType(){//
      this.httpGet("web/info/queryNewsTypeList").then(res => {
        if(res.success){
          let type = {};
          type.id='';
          type.typeName='全部';
          this.typelist.push(type);
          let list = res.result;
          for(var i=0;i<list.length;i++){
            this.typelist.push(list[i]);
          }
          this.init();
        }
      });
    },
    //变化类型
    changetab(index,item) {
      this.pageNo=1
      this.indexsign = index;
      this.typeId = item.id;
      this.init();
    },
    init() {
      var that = this;
      // var val = "sendTime";
      // if (this.$route.query.type == 2) {
      //   val = "views";
      // }
      this.httpGet("web/info/list", {
		infoType: "6",
        newsTypeId: this.typeId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        that.list = res.result.records;
        that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    pageNum(e) {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      this.pageNo = e;
      this.init();
    },
  },
  mounted() {},
};
</script>
<style scoped="scoped" lang="scss">

.newscenter {
  width: 100%;
  position: relative;
  .pic {
    width: 100%;
    height: 400px;
    font-size:75px;
    font-weight: 500;
    color: #e61f26;
    text-align: center;
    line-height: 400px;
    margin-top: 100px;
    background: url(../../assets/newimg/publicannounce_img.png) no-repeat top
      center/ 100% 100%;
  }
  .body {
    background: #ffffff;
    margin:20px auto 0;
    .centent {
      margin: 20px auto;
      .lista {
        width: 100%;
        height:37px;
        background: #fbfbfb;
        display: flex;
        align-items: center;
        .listsignle {
          display: flex;
          align-items: center;
        }
        .signlea,.signlea_cur{
          width: 107px;
          height:37px;
          line-height:37px;
          text-align: center;
          font-size: 16px;
          cursor: pointer;
        }
        .signlea {
          color: #666666;
        }
        .signlea_cur {
          background: #e70012;
          color: #ffffff;
        }
        .linecon {
          width: 1px;
          height:17px;
          background: #666666;
          opacity: 0.3;
        }
      }

      .listb {
        margin-top:40px;
        .signleb {
          padding-left: 20px;
          cursor: pointer;
          height:70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          border-bottom: 1px dashed #e6e6e6;
          .titlecon {
            font-size:18px;
            font-weight: 400;
            color: #333333;
            width: calc(100% - 170px);
          }
          .titlecon:hover {
            color: rgba(230, 31, 38, 1);
          }
          .timecon {
            font-size:18px;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
    .zhini-pagination {
      position: absolute;
      bottom: 55px;
      width: 100%;
      left: 0px;
    }

    .toptitle {
      height:60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_c {
        display: flex;
        align-items: center;
        .redcon {
          width: 5px;
          height:20px;
          background: #e70012;
          margin-right: 20px;
        }
        font-size:25px;
        font-weight: 400;
        color: #e61f26;
      }
    }
  }
}
</style>
